import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import user1 from '../Img/user.png';
import ExpenseModal from './ExpenseModal';
import OfferingModal from './OfferingModal';
import CouponModal from './CouponModal';
import PlanModal from './PlanModal';
import UpdateModal from './UpdateModal';
import BranchModal from './BranchModal';
import ClassAgeGroupModal from './ClassAgeGroupModal';
import ClassLevelModal from './ClassLevelModal';
import ClassScheduleModal from './ClassScheduleModal';
import ReceivedPaymentModal from './ReceivedPaymentModal';
import DuePaymentModal from './DuePaymentModal';
import AddProject from './AddProject';
import CryptoJS from "crypto-js";
import { getDecryptedUserFromCookie } from './utils/getCookie';
import { clearAdminSession } from '../modules/saas/utils/session';
import { useSearch } from '../SearchContext';
import MobileBottomNav from './MobileBottom';

const Header = () => {
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [isQuickCreateOpen, setQuickCreateOpen] = useState(false);
    const [isProfileMenuOpen, setProfileMenuOpen] = useState(false);
    const quickCreateRef = useRef(null);
    const profileMenuRef = useRef(null);
    const [isExpenseOpen, setIsExpenseOpen] = useState(false);
    const [isOfferingOpen, setIsOfferingOpen] = useState(false);
    const [isCouponOpen, setIsCouponOpen] = useState(false);
    const [isPlanOpen, setIsPlanOpen] = useState(false);
    const [isUpdateOpen, setIsUpdateOpen] = useState(false);
    const [isBranchOpen, setIsBranchOpen] = useState(false);
    const [isAgeGroupOpen, setIsAgeGroupOpen] = useState(false);
    const [isClassLevelOpen, setIsClassLevelOpen] = useState(false);
    const [isClassScheduleOpen, setIsClassScheduleOpen] = useState(false);
    const [isReceivedFeesOpen, setIsReceivedFeesOpen] = useState(false);
    const [isDueFeesOpen, setIsDueFeesOpen] = useState(false);
    const [isActivityOpen, setIsActivityOpen] = useState(false);
    const urlmain = API_BASE_URL
    const { setGlobalSearch } = useSearch();
    // const login = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12")) || ""
    const login = "hello"
    const user = getDecryptedUserFromCookie("2xgxgshdugyywerw12");




    const navigate = useNavigate();
    // Function to toggle Quick Create menu
    const toggleQuickCreate = () => {
        setQuickCreateOpen(prevState => !prevState);
        setProfileMenuOpen(false); // Close profile menu if open
    };

    // Function to toggle Profile menu
    const toggleProfileMenu = () => {
        setProfileMenuOpen(prevState => !prevState);
        setQuickCreateOpen(false); // Close quick create menu if open
    };



    const handleSearchChange = (e) => {
        setGlobalSearch(e.target.value);
    };

    // Close menus if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                quickCreateRef.current && !quickCreateRef.current.contains(event.target) &&
                !event.target.closest('.quick-create')
            ) {
                setQuickCreateOpen(false);
            }
            if (
                profileMenuRef.current && !profileMenuRef.current.contains(event.target) &&
                !event.target.closest('.header-profile')
            ) {
                setProfileMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handlelogout = async () => {
        try {
            clearAdminSession();
            navigate("/login", { replace: true });
        } catch (err) {
            console.error("Logout failed:", err);
        }
    };


    return (
        <>
            <div className={`header ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="header-list hamburger-search">
                    <div className="header-hamburger" onClick={toggleSidebar}>
                        <i className="fas fa-bars"></i>
                    </div>
                    <div className="search-container">
                        <input
                            type="text"
                            placeholder="Search..."
                            onChange={handleSearchChange}
                        />
                        <i className="fas fa-search search-icon"></i>
                    </div>
                </div>
                <div className="header-list header-list2">
                    <div className="notification">
                        <i className="fa-regular fa-bell"></i>
                    </div>
                    {/* <div className="quick-create">
                        <button onClick={toggleQuickCreate}>Quick create</button>
                    </div> */}
                    {isQuickCreateOpen && (
                        <div className="quick-create-menu" ref={quickCreateRef}>
                            <Link to='/add-customer-2'><button>+ Customer</button></Link>
                            <Link to='/new-invoice'><button>+ Invoice</button></Link>
                            <button onClick={() => setIsOfferingOpen(true)}>+ Offerings</button>
                            <button onClick={() => setIsCouponOpen(true)}>+ Coupon</button>
                            <button onClick={() => setIsPlanOpen(true)}>+ Plan</button>
                            <button onClick={() => setIsUpdateOpen(true)}>+ Update</button>
                            <button onClick={() => setIsExpenseOpen(true)}>+ Expense</button>
                            <button onClick={() => setIsBranchOpen(true)}>+ Branch</button>
                            <button onClick={() => setIsAgeGroupOpen(true)}>+ Age Group</button>
                            <button onClick={() => setIsClassLevelOpen(true)}>+ Class Level</button>
                            <button onClick={() => setIsClassScheduleOpen(true)}>+ Class Schedule</button>
                            <button onClick={() => setIsReceivedFeesOpen(true)}>+ Received Fees</button>
                            <button onClick={() => setIsDueFeesOpen(true)}>+ Due Fees</button>
                            <button onClick={() => setIsActivityOpen(true)}>+ Activity</button>
                        </div>
                    )}
                    <div className="header-profile" onClick={toggleProfileMenu}>
                        <div className="profile-img">
                            <img src={user1} alt="User Profile" />
                        </div>
                        {isProfileMenuOpen && (
                            <div className="profile-menu" ref={profileMenuRef}>
                                <ul>
                                    <li onClick={() => navigate("/setting")}><i className="fa fa-user"></i> Profile</li>
                                    <li onClick={handlelogout}><i className="fa fa-sign-out-alt"></i> Logout</li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Modals */}
            <ExpenseModal isOpen={isExpenseOpen} setIsOpen={setIsExpenseOpen} title="Expense Modal" />
            <OfferingModal isOpen={isOfferingOpen} setIsOpen={setIsOfferingOpen} title="Offering Modal" />
            <CouponModal isOpen={isCouponOpen} setIsOpen={setIsCouponOpen} title="Coupon Modal" />
            <PlanModal isOpen={isPlanOpen} setIsOpen={setIsPlanOpen} title="Plan Modal" />
            <UpdateModal isOpen={isUpdateOpen} setIsOpen={setIsUpdateOpen} title="Update Modal" />
            <BranchModal isOpen={isBranchOpen} setIsOpen={setIsBranchOpen} title="Branch Modal" />
            <ClassAgeGroupModal isOpen={isAgeGroupOpen} setIsOpen={setIsAgeGroupOpen} title="Age Group Modal" />
            <ClassLevelModal isOpen={isClassLevelOpen} setIsOpen={setIsClassLevelOpen} title="Class Level Modal" />
            <ClassScheduleModal isOpen={isClassScheduleOpen} setIsOpen={setIsClassScheduleOpen} title="Class Schedule Modal" />
            <ReceivedPaymentModal isOpen={isReceivedFeesOpen} setIsOpen={setIsReceivedFeesOpen} title="Received Fees Modal" />
            <DuePaymentModal isOpen={isDueFeesOpen} setIsOpen={setIsDueFeesOpen} title="Due Fees Modal" />
            <AddProject isOpen={isActivityOpen} setIsOpen={setIsActivityOpen} title="Activity Modal" />
            <MobileBottomNav />
        </>
    );
};

export default Header;
